import { featuredSpreadsheets } from "@/mocks/homeData";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-6xl mx-auto">
        {/* Section heading */}
        <div className="mb-10 md:mb-14">
          <span className="text-xs uppercase tracking-widest text-secondary-500 font-label">/ Featured Spreadsheets</span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-semibold text-foreground-950 mt-3 mb-3">
            Top <strong>Mulebuy Spreadsheet</strong> Collections Compared
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl">
            We have evaluated and ranked the most popular spreadsheets based on update frequency, category coverage, and overall quality.
          </p>
        </div>

        {/* Table - desktop */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Rank</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Spreadsheet</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Category</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Update</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Quality</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Notes</th>
                <th className="text-left py-4 px-4 text-xs uppercase tracking-wider text-foreground-400 font-label font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {featuredSpreadsheets.map((sheet) => (
                <tr key={sheet.rank} className="border-b border-background-200/60 hover:bg-background-50/70 transition-colors">
                  <td className="py-4 px-4">
                    <span className="w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center">
                      {sheet.rank}
                    </span>
                  </td>
                  <td className="py-4 px-4 font-medium text-foreground-900 text-sm">{sheet.name}</td>
                  <td className="py-4 px-4">
                    <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{sheet.category}</span>
                  </td>
                  <td className="py-4 px-4 text-sm text-foreground-600">{sheet.updateFrequency}</td>
                  <td className="py-4 px-4">
                    <span className="text-sm font-semibold text-primary-600">{sheet.qualityScore}/10</span>
                  </td>
                  <td className="py-4 px-4 text-sm text-foreground-500 max-w-xs">{sheet.notes}</td>
                  <td className="py-4 px-4">
                    <a
                      href="https://kaspreadsheet.com/"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs font-medium text-accent-600 hover:text-accent-700 whitespace-nowrap cursor-pointer"
                    >
                      View <i className="ri-arrow-right-up-line text-xs"></i>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards - mobile */}
        <div className="md:hidden space-y-4">
          {featuredSpreadsheets.map((sheet) => (
            <div key={sheet.rank} className="bg-background-50 rounded-2xl p-5 border border-background-200/70">
              <div className="flex items-center justify-between mb-3">
                <span className="w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center">
                  {sheet.rank}
                </span>
                <span className="text-sm font-semibold text-primary-600">{sheet.qualityScore}/10</span>
              </div>
              <h3 className="font-medium text-foreground-900 mb-1">{sheet.name}</h3>
              <div className="flex items-center gap-3 mb-2">
                <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{sheet.category}</span>
                <span className="text-xs text-foreground-500">{sheet.updateFrequency}</span>
              </div>
              <p className="text-sm text-foreground-500 mb-3">{sheet.notes}</p>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs font-medium text-accent-600 hover:text-accent-700 cursor-pointer"
              >
                View Spreadsheet <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}